var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"placement":_vm.position,"effect":_vm.theme}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_c('i',{staticClass:"el-icon-question"})])}
var staticRenderFns = []

export { render, staticRenderFns }